<div class="dd-v-spec-local-special">
	<dd-vehicle-detail-header [vehicleDetails]="vehicle" [sharedData]="shared"></dd-vehicle-detail-header>
	<dd-app-menu></dd-app-menu>
	<div>
		<dd-page-title [title]="'Local Specials'"></dd-page-title>
	</div>
	<div class="dd-v-spec-local-special-container">
		<ul class="dd-v-spec-local-special-cards">
			<li class="dd-v-spec-local-special-card" *ngFor="let card of cards">
				<rti-local-special-card [data]="card"></rti-local-special-card>
			</li>
		</ul>
	</div>
	<rti-modal-dialog *onActionClick=[handleCardEvent] [actions]="dialogActions">
		<h2>{{card.label}}</h2>
	</rti-modal-dialog>
</div>
